import type { ReactNode } from 'react';
import { useTenant } from '../../providers/TenantProvider';

interface CanAccessProps {
  requiredPermission: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export function CanAccess({ requiredPermission, children, fallback = null }: CanAccessProps) {
  const { tenantPermissions } = useTenant();

  if (tenantPermissions.includes(requiredPermission)) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
}
